import { inject, Injectable } from '@angular/core';
import { KeycloakSessionService } from './auth/keycloak-session.service';

@Injectable({ providedIn: 'root' })
export class AdministrativeAccessService {
  private readonly session = inject(KeycloakSessionService);

  canEnter(): boolean {
    return this.session.isSecurityAdministrator;
  }

  canOpen(path: string): boolean {
    return (
      this.canEnter() &&
      (path === '/access-admin' || path.startsWith('/access-admin/'))
    );
  }

  firstPage(): string | undefined {
    return this.canEnter() ? '/access-admin/event-log' : undefined;
  }
}
